import { render, staticRenderFns } from "./NewCustomerBtn.vue?vue&type=template&id=29b85026&scoped=true&"
import script from "./NewCustomerBtn.vue?vue&type=script&lang=js&"
export * from "./NewCustomerBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b85026",
  null
  
)

export default component.exports